const Hr = () => {
  return <hr className="mx-auto my-10 w-32 border-t-2 border-t-accent-500" />
}

export default Hr
